import React, {useState} from "react";
import {ImageCropper} from "../../shared";
import ReactModal from 'react-modal';

import './imageProfile.scss';


// Set the app element for react-modal
ReactModal.setAppElement('#root');

function ImageProfile({image, handleProfilePictureUpload}) {

    const [profilePick, setProfilePick] = useState(image);
    const [cropImage, setCropImage] = useState(null);
    const [loading, setLoading] = useState(false);
    const [modalCropOpen, setModalCropOpen] = useState(false);

    const handleImageClick = () => {

        if (loading) {
            return;
        }
        const input = document.createElement('input');
        input.type = 'file';
        input.accept = 'image/*';

        input.onchange = async (event) => {
            const file = event.target.files[0];
            if (file) {
                // Check if the file is a GIF
                if (file.type === 'image/gif') {
                    // For GIFs, upload directly without cropping
                    setLoading(true);
                    const newPicture = await handleProfilePictureUpload(file);
                    setProfilePick(newPicture);
                    setLoading(false);
                } else {
                    // For other image types, use the crop modal
                    setCropImage(URL.createObjectURL(file));
                    setModalCropOpen(true);
                }
            }
        };

        input.click();
    };

    const handleCloseModal = () => {
        setModalCropOpen(false);
    };

    const handleCrop = async (croppedImage) => {
        setLoading(true);
        const newPicture = await handleProfilePictureUpload(croppedImage);
        setProfilePick(newPicture);
        setLoading(false);
    };

    return (
        <div className="">
            <ImageCropper image={cropImage} onClose={handleCloseModal} open={modalCropOpen} onCrop={handleCrop}/>
            <div className="">
                <div className="image-profile-form-input" onClick={handleImageClick}>
                    <div className="image-profile-form-input__over-image">
                        <i className="fa-solid fa-images"></i>
                    </div>
                    {!loading && <img alt='User photo url' src={profilePick}/>}
                    {loading &&
                        <div className="d-flex justify-content-center align-items-center" style={{height: '100%'}}>
                            <div className="spinner-border spinner-border-md" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>}
                </div>
            </div>
        </div>);

}

export default ImageProfile;
